import { serviceBase } from "../../../service";

const GroupContact = {
  ...serviceBase,
  preList: function(params) {
    delete params.id;
    return `projects/${params.project_id || "-"}/groups/${params.group_id}`;
  },
  preListOption: {
    getList: true,
    get: true,
    create: true,
    update: true,
    delete: true,
    deleteList: true
  },
  resource: "authorizations"
};
GroupContact.create = GroupContact.update;
export default GroupContact;
